// **********************************************************
// Large slider
// **********************************************************

const largeSlider = document.querySelectorAll('[data-slider="large-slider"]');

const largeSliderOptions = {
  slidesPerView: 1,
  speed: 800,
  watchOverflow: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  grabCursor: true,
  effect: 'creative',
  creativeEffect: {
    prev: {
      shadow: true,
      translate: ['-110%', 0, -500],
    },
    next: {
      shadow: true,
      translate: ['110%', 0, -500],
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

largeSlider.forEach((el) => {
  const parent = el.closest('.large-slider');
  const paginationElement = parent.querySelector('.swiper-pagination');

  const arrowRight = parent.querySelector('.arrow-right');
  const arrowLeft = parent.querySelector('.arrow-left');

  largeSliderOptions.navigation.nextEl = arrowRight;
  largeSliderOptions.navigation.prevEl = arrowLeft;

  largeSliderOptions.pagination.el = paginationElement;

  const largeSliderElem = new Swiper(el, largeSliderOptions);

  attachEvent('.large-slider .swiper-slide-prev', 'click', (ev) => {
    largeSliderElem.slidePrev(800);
    ev.preventDefault();
  });

  attachEvent('.large-slider .swiper-slide-next', 'click', (ev) => {
    largeSliderElem.slideNext(800);
    ev.preventDefault();
  });
});
